var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQutLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 101.7 101.3",
    style: {
      backgroundColor: "#003562"
    },
    xmlSpace: "preserve",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#003562",
    d: "M0-0.3h101.7v101.6H0V-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M44.2,31.5v27.3c0,1.9,2.4,10.7,14.5,10.7s14.1-8.8,14.1-10.6V43.2l-9.3-9.8v24.4c0,0.5,0.1,2.9-4.8,2.9 c-5,0-5-2.4-5-3V31.5H44.2L44.2,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M64.4,31.5l8.9,9.2h6.4v28.2h9.7V40.7h7.5v-9.2H64.4z M39.3,60.9l8,8.1H36.5L19.1,50.8h10.4l2.7,2.8 c0.4-0.9,0.6-1.9,0.6-3.5c0-5.6-4.7-9.9-10.1-9.9s-9.7,4.6-9.7,10c0,5.4,4.4,9.9,9.9,9.9c0.6,0,1.2,0,1.8-0.2 c0.1,0,7.2,7.7,7.2,7.7c-2,1.4-5.9,2.2-8.9,2.2C12.3,69.7,4,60.6,4,50.3s8.4-19.1,19.2-19.1S42.5,40,42.5,50.6 C42.4,55,40.3,59.3,39.3,60.9L39.3,60.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQutLogo);
export default __webpack_public_path__ + "static/media/qut_logo.95e385da996a037d3b8ce8978b37f78a.svg";
export { ForwardRef as ReactComponent };